import AsyncStorage from '@react-native-async-storage/async-storage';

const DRAFT_STORAGE_KEY = '@pixelsky:draft';

export interface Draft {
  text: string;
  images: string[];
  createdAt: string;
  replyTo?: {
    uri: string;
    cid: string;
    rootUri?: string;
    rootCid?: string;
    authorHandle: string;
  };
}

/**
 * 下書きを保存
 */
export const saveDraft = async (draft: Draft): Promise<void> => {
  try {
    await AsyncStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(draft));
  } catch (error) {
    console.error('Save draft error:', error);
    throw error;
  }
};

/**
 * 下書きを取得
 */
export const loadDraft = async (): Promise<Draft | null> => {
  try {
    const draftJson = await AsyncStorage.getItem(DRAFT_STORAGE_KEY);
    if (!draftJson) return null;
    
    return JSON.parse(draftJson);
  } catch (error) {
    console.error('Load draft error:', error);
    return null;
  }
};

/**
 * 下書きを削除
 */
export const clearDraft = async (): Promise<void> => {
  try {
    await AsyncStorage.removeItem(DRAFT_STORAGE_KEY);
  } catch (error) {
    console.error('Clear draft error:', error);
    throw error;
  }
};
